<template>
  <main class="help-page">
    <!-- Croix arménienne (khatchkar) : réutilisée via <use> -->
    <svg width="0" height="0" style="position:absolute" aria-hidden="true" focusable="false">
      <symbol id="hk-cross" viewBox="-34 -40 453 752">
<mask id="hkm" maskUnits="userSpaceOnUse" x="-20" y="-20" width="425" height="710"><rect x="-20" y="-20" width="425" height="710" fill="#fff"/><path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="#000" stroke-width="5" stroke-linejoin="round"/></mask>
<path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="currentColor" stroke-width="17" stroke-linejoin="round" mask="url(#hkm)"/>
<g transform="translate(98 40) rotate(-45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(287 40) rotate(45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 166) rotate(70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 344) rotate(110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(291 645) rotate(135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(97 645) rotate(-135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 344) rotate(-110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 166) rotate(-70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<circle cx="140" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="140" cy="44" r="5.7" fill="currentColor"/>
<circle cx="245" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="245" cy="44" r="5.7" fill="currentColor"/>
<circle cx="112" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="112" cy="88" r="5.7" fill="currentColor"/>
<circle cx="272" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="272" cy="88" r="5.7" fill="currentColor"/>
<circle cx="48" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="48" cy="208" r="5.7" fill="currentColor"/>
<circle cx="48" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="48" cy="302" r="5.7" fill="currentColor"/>
<circle cx="338" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="338" cy="208" r="5.7" fill="currentColor"/>
<circle cx="338" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="338" cy="302" r="5.7" fill="currentColor"/>
<circle cx="140" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="140" cy="602" r="5.7" fill="currentColor"/>
<circle cx="245" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="245" cy="602" r="5.7" fill="currentColor"/>
<circle cx="110" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="110" cy="592" r="5.7" fill="currentColor"/>
<circle cx="275" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="275" cy="592" r="5.7" fill="currentColor"/>
<circle cx="192" cy="245" r="74" fill="none" stroke="currentColor" stroke-width="5"/>
<line x1="252.0" y1="245.0" x2="265.0" y2="245.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="251.1" y1="255.4" x2="263.9" y2="257.7" stroke="currentColor" stroke-width="2.5"/>
<line x1="248.4" y1="265.5" x2="260.6" y2="270.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="244.0" y1="275.0" x2="255.2" y2="281.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="238.0" y1="283.6" x2="247.9" y2="291.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="230.6" y1="291.0" x2="238.9" y2="300.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="222.0" y1="297.0" x2="228.5" y2="308.2" stroke="currentColor" stroke-width="2.5"/>
<line x1="212.5" y1="301.4" x2="217.0" y2="313.6" stroke="currentColor" stroke-width="2.5"/>
<line x1="202.4" y1="304.1" x2="204.7" y2="316.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="192.0" y1="305.0" x2="192.0" y2="318.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="181.6" y1="304.1" x2="179.3" y2="316.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="171.5" y1="301.4" x2="167.0" y2="313.6" stroke="currentColor" stroke-width="2.5"/>
<line x1="162.0" y1="297.0" x2="155.5" y2="308.2" stroke="currentColor" stroke-width="2.5"/>
<line x1="153.4" y1="291.0" x2="145.1" y2="300.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="146.0" y1="283.6" x2="136.1" y2="291.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="140.0" y1="275.0" x2="128.8" y2="281.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="135.6" y1="265.5" x2="123.4" y2="270.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="132.9" y1="255.4" x2="120.1" y2="257.7" stroke="currentColor" stroke-width="2.5"/>
<line x1="132.0" y1="245.0" x2="119.0" y2="245.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="132.9" y1="234.6" x2="120.1" y2="232.3" stroke="currentColor" stroke-width="2.5"/>
<line x1="135.6" y1="224.5" x2="123.4" y2="220.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="140.0" y1="215.0" x2="128.8" y2="208.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="146.0" y1="206.4" x2="136.1" y2="198.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="153.4" y1="199.0" x2="145.1" y2="189.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="162.0" y1="193.0" x2="155.5" y2="181.8" stroke="currentColor" stroke-width="2.5"/>
<line x1="171.5" y1="188.6" x2="167.0" y2="176.4" stroke="currentColor" stroke-width="2.5"/>
<line x1="181.6" y1="185.9" x2="179.3" y2="173.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="192.0" y1="185.0" x2="192.0" y2="172.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="202.4" y1="185.9" x2="204.7" y2="173.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="212.5" y1="188.6" x2="217.0" y2="176.4" stroke="currentColor" stroke-width="2.5"/>
<line x1="222.0" y1="193.0" x2="228.5" y2="181.8" stroke="currentColor" stroke-width="2.5"/>
<line x1="230.6" y1="199.0" x2="238.9" y2="189.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="238.0" y1="206.4" x2="247.9" y2="198.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="244.0" y1="215.0" x2="255.2" y2="208.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="248.4" y1="224.5" x2="260.6" y2="220.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="251.1" y1="234.6" x2="263.9" y2="232.3" stroke="currentColor" stroke-width="2.5"/>
<circle cx="192" cy="245" r="52" fill="none" stroke="currentColor" stroke-width="6"/>
<path d="M202.0 245.0 L205.5 246.7 L208.7 249.3 L211.4 252.6 L213.4 256.7 L214.7 261.4 L215.1 266.5 L214.6 272.0 L213.0 277.6 L210.3 283.3 L206.5 288.7" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M199.1 252.1 L200.3 255.7 L200.8 259.8 L200.3 264.1 L198.9 268.4 L196.5 272.6 L193.1 276.6 L188.9 280.1 L183.7 282.9 L177.9 285.0 L171.4 286.1" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M192.0 255.0 L190.3 258.5 L187.7 261.7 L184.4 264.4 L180.3 266.4 L175.6 267.7 L170.5 268.1 L165.0 267.6 L159.4 266.0 L153.7 263.3 L148.3 259.5" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M184.9 252.1 L181.3 253.3 L177.2 253.8 L172.9 253.3 L168.6 251.9 L164.4 249.5 L160.4 246.1 L156.9 241.9 L154.1 236.7 L152.0 230.9 L150.9 224.4" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M182.0 245.0 L178.5 243.3 L175.3 240.7 L172.6 237.4 L170.6 233.3 L169.3 228.6 L168.9 223.5 L169.4 218.0 L171.0 212.4 L173.7 206.7 L177.5 201.3" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M184.9 237.9 L183.7 234.3 L183.2 230.2 L183.7 225.9 L185.1 221.6 L187.5 217.4 L190.9 213.4 L195.1 209.9 L200.3 207.1 L206.1 205.0 L212.6 203.9" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M192.0 235.0 L193.7 231.5 L196.3 228.3 L199.6 225.6 L203.7 223.6 L208.4 222.3 L213.5 221.9 L219.0 222.4 L224.6 224.0 L230.3 226.7 L235.7 230.5" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M199.1 237.9 L202.7 236.7 L206.8 236.2 L211.1 236.7 L215.4 238.1 L219.6 240.5 L223.6 243.9 L227.1 248.1 L229.9 253.3 L232.0 259.1 L233.1 265.6" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="192" cy="245" r="8" fill="currentColor"/>
<path d="M192.0 330.0 L195.0 333.0 L197.9 336.0 L200.6 339.0 L203.0 342.0 L205.1 345.0 L206.8 348.0 L208.1 351.0 L208.8 354.0 L209.0 357.0 L208.7 360.0 L207.8 363.0 L206.5 366.0 L204.7 369.0 L202.6 372.0 L200.1 375.0 L197.3 378.0 L194.4 381.0 L191.4 384.0 L188.4 387.0 L185.6 390.0 L182.9 393.0 L180.5 396.0 L178.5 399.0 L176.9 402.0 L175.8 405.0 L175.1 408.0 L175.0 411.0 L175.4 414.0 L176.4 417.0 L177.8 420.0 L179.7 423.0 L181.9 426.0 L184.5 429.0 L187.2 432.0 L190.2 435.0 L193.2 438.0 L196.1 441.0 L199.0 444.0 L201.6 447.0 L203.9 450.0 L205.8 453.0 L207.4 456.0 L208.4 459.0 L208.9 462.0 L208.9 465.0 L208.4 468.0 L207.4 471.0 L205.9 474.0 L203.9 477.0 L201.6 480.0 L199.0 483.0 L196.2 486.0 L193.2 489.0 L190.2 492.0 L187.3 495.0 L184.5 498.0 L181.9 501.0 L179.7 504.0 L177.8 507.0 L176.4 510.0 L175.5 513.0 L175.0 516.0 L175.1 519.0 L175.8 522.0 L176.9 525.0 L178.5 528.0 L180.5 531.0 L182.9 534.0 L185.5 537.0 L188.4 540.0 L191.4 543.0" fill="none" stroke="currentColor" stroke-width="7" stroke-linecap="round"/>
<path d="M192.0 330.0 L189.0 333.0 L186.1 336.0 L183.4 339.0 L181.0 342.0 L178.9 345.0 L177.2 348.0 L175.9 351.0 L175.2 354.0 L175.0 357.0 L175.3 360.0 L176.2 363.0 L177.5 366.0 L179.3 369.0 L181.4 372.0 L183.9 375.0 L186.7 378.0 L189.6 381.0 L192.6 384.0 L195.6 387.0 L198.4 390.0 L201.1 393.0 L203.5 396.0 L205.5 399.0 L207.1 402.0 L208.2 405.0 L208.9 408.0 L209.0 411.0 L208.6 414.0 L207.6 417.0 L206.2 420.0 L204.3 423.0 L202.1 426.0 L199.5 429.0 L196.8 432.0 L193.8 435.0 L190.8 438.0 L187.9 441.0 L185.0 444.0 L182.4 447.0 L180.1 450.0 L178.2 453.0 L176.6 456.0 L175.6 459.0 L175.1 462.0 L175.1 465.0 L175.6 468.0 L176.6 471.0 L178.1 474.0 L180.1 477.0 L182.4 480.0 L185.0 483.0 L187.8 486.0 L190.8 489.0 L193.8 492.0 L196.7 495.0 L199.5 498.0 L202.1 501.0 L204.3 504.0 L206.2 507.0 L207.6 510.0 L208.5 513.0 L209.0 516.0 L208.9 519.0 L208.2 522.0 L207.1 525.0 L205.5 528.0 L203.5 531.0 L201.1 534.0 L198.5 537.0 L195.6 540.0 L192.6 543.0" fill="none" stroke="currentColor" stroke-width="7" stroke-linecap="round"/>
<circle cx="192" cy="330.0" r="3.5" fill="currentColor"/>
<circle cx="192" cy="356.7" r="3.5" fill="currentColor"/>
<circle cx="192" cy="383.4" r="3.5" fill="currentColor"/>
<circle cx="192" cy="410.1" r="3.5" fill="currentColor"/>
<circle cx="192" cy="436.8" r="3.5" fill="currentColor"/>
<circle cx="192" cy="463.5" r="3.5" fill="currentColor"/>
<circle cx="192" cy="490.2" r="3.5" fill="currentColor"/>
<g transform="translate(192 170) rotate(0)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="4" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<g transform="translate(192 555) rotate(180)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="4" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<path d="M192 560 L165 590 L192 600 L219 590Z" fill="none" stroke="currentColor" stroke-width="4" stroke-linejoin="round"/>
      </symbol>
      <symbol id="hk-cross-sm" viewBox="-44 -40 473 752">
<mask id="hkm-sm" maskUnits="userSpaceOnUse" x="-20" y="-20" width="425" height="710"><rect x="-20" y="-20" width="425" height="710" fill="#fff"/><path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="#000" stroke-width="6" stroke-linejoin="round"/></mask>
<path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="currentColor" stroke-width="19" stroke-linejoin="round" mask="url(#hkm-sm)"/>
<g transform="translate(98 40) rotate(-45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(287 40) rotate(45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 166) rotate(70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 344) rotate(110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(291 645) rotate(135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(97 645) rotate(-135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 344) rotate(-110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 166) rotate(-70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<circle cx="140" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="140" cy="44" r="7" fill="currentColor"/>
<circle cx="245" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="245" cy="44" r="7" fill="currentColor"/>
<circle cx="112" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="112" cy="88" r="7" fill="currentColor"/>
<circle cx="272" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="272" cy="88" r="7" fill="currentColor"/>
<circle cx="48" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="48" cy="208" r="7" fill="currentColor"/>
<circle cx="48" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="48" cy="302" r="7" fill="currentColor"/>
<circle cx="338" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="338" cy="208" r="7" fill="currentColor"/>
<circle cx="338" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="338" cy="302" r="7" fill="currentColor"/>
<circle cx="140" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="140" cy="602" r="7" fill="currentColor"/>
<circle cx="245" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="245" cy="602" r="7" fill="currentColor"/>
<circle cx="110" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="110" cy="592" r="7" fill="currentColor"/>
<circle cx="275" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="275" cy="592" r="7" fill="currentColor"/>
<circle cx="192" cy="245" r="76" fill="none" stroke="currentColor" stroke-width="8"/>
<line x1="254.0" y1="245.0" x2="266.0" y2="245.0" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="250.3" y1="266.2" x2="261.5" y2="270.3" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="239.5" y1="284.9" x2="248.7" y2="292.6" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="223.0" y1="298.7" x2="229.0" y2="309.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="202.8" y1="306.1" x2="204.8" y2="317.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="181.2" y1="306.1" x2="179.2" y2="317.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="161.0" y1="298.7" x2="155.0" y2="309.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="144.5" y1="284.9" x2="135.3" y2="292.6" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="133.7" y1="266.2" x2="122.5" y2="270.3" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="130.0" y1="245.0" x2="118.0" y2="245.0" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="133.7" y1="223.8" x2="122.5" y2="219.7" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="144.5" y1="205.1" x2="135.3" y2="197.4" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="161.0" y1="191.3" x2="155.0" y2="180.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="181.2" y1="183.9" x2="179.2" y2="172.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="202.8" y1="183.9" x2="204.8" y2="172.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="223.0" y1="191.3" x2="229.0" y2="180.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="239.5" y1="205.1" x2="248.7" y2="197.4" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="250.3" y1="223.8" x2="261.5" y2="219.7" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<circle cx="192" cy="245" r="54" fill="none" stroke="currentColor" stroke-width="9"/>
<path d="M207.0 245.0 L209.9 247.4 L212.4 250.7 L214.3 254.6 L215.5 259.1 L215.8 264.1 L215.2 269.3 L213.5 274.7 L210.8 280.1 L206.9 285.2 L202.1 289.9" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M201.4 256.7 L201.3 260.5 L200.3 264.5 L198.4 268.4 L195.6 272.2 L191.9 275.5 L187.4 278.3 L182.1 280.4 L176.3 281.6 L169.9 281.8 L163.2 280.9" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M188.7 259.6 L185.6 261.9 L181.9 263.7 L177.7 264.6 L173.0 264.8 L168.1 264.0 L163.1 262.2 L158.2 259.3 L153.6 255.5 L149.5 250.6 L146.0 244.8" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M178.5 251.5 L174.8 250.6 L171.1 248.8 L167.7 246.1 L164.7 242.5 L162.3 238.2 L160.6 233.1 L159.7 227.5 L159.9 221.5 L161.1 215.3 L163.4 208.9" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M178.5 238.5 L176.9 235.0 L176.0 231.0 L176.0 226.7 L176.9 222.1 L178.8 217.5 L181.7 213.0 L185.5 208.9 L190.3 205.2 L196.0 202.3 L202.4 200.2" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M188.7 230.4 L190.4 227.0 L193.0 223.8 L196.4 221.1 L200.5 219.0 L205.3 217.5 L210.6 217.0 L216.2 217.4 L222.0 218.9 L227.9 221.5 L233.5 225.2" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M201.4 233.3 L205.1 232.5 L209.2 232.6 L213.4 233.5 L217.7 235.4 L221.7 238.3 L225.5 242.1 L228.7 246.7 L231.1 252.2 L232.8 258.4 L233.4 265.1" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="192" cy="245" r="9" fill="currentColor"/>
<path d="M192.0 330.0 L195.0 333.0 L197.9 336.0 L200.6 339.0 L203.0 342.0 L205.1 345.0 L206.8 348.0 L208.1 351.0 L208.8 354.0 L209.0 357.0 L208.7 360.0 L207.8 363.0 L206.5 366.0 L204.7 369.0 L202.6 372.0 L200.1 375.0 L197.3 378.0 L194.4 381.0 L191.4 384.0 L188.4 387.0 L185.6 390.0 L182.9 393.0 L180.5 396.0 L178.5 399.0 L176.9 402.0 L175.8 405.0 L175.1 408.0 L175.0 411.0 L175.4 414.0 L176.4 417.0 L177.8 420.0 L179.7 423.0 L181.9 426.0 L184.5 429.0 L187.2 432.0 L190.2 435.0 L193.2 438.0 L196.1 441.0 L199.0 444.0 L201.6 447.0 L203.9 450.0 L205.8 453.0 L207.4 456.0 L208.4 459.0 L208.9 462.0 L208.9 465.0 L208.4 468.0 L207.4 471.0 L205.9 474.0 L203.9 477.0 L201.6 480.0 L199.0 483.0 L196.2 486.0 L193.2 489.0 L190.2 492.0 L187.3 495.0 L184.5 498.0 L181.9 501.0 L179.7 504.0 L177.8 507.0 L176.4 510.0 L175.5 513.0 L175.0 516.0 L175.1 519.0 L175.8 522.0 L176.9 525.0 L178.5 528.0 L180.5 531.0 L182.9 534.0 L185.5 537.0 L188.4 540.0 L191.4 543.0" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round"/>
<path d="M192.0 330.0 L189.0 333.0 L186.1 336.0 L183.4 339.0 L181.0 342.0 L178.9 345.0 L177.2 348.0 L175.9 351.0 L175.2 354.0 L175.0 357.0 L175.3 360.0 L176.2 363.0 L177.5 366.0 L179.3 369.0 L181.4 372.0 L183.9 375.0 L186.7 378.0 L189.6 381.0 L192.6 384.0 L195.6 387.0 L198.4 390.0 L201.1 393.0 L203.5 396.0 L205.5 399.0 L207.1 402.0 L208.2 405.0 L208.9 408.0 L209.0 411.0 L208.6 414.0 L207.6 417.0 L206.2 420.0 L204.3 423.0 L202.1 426.0 L199.5 429.0 L196.8 432.0 L193.8 435.0 L190.8 438.0 L187.9 441.0 L185.0 444.0 L182.4 447.0 L180.1 450.0 L178.2 453.0 L176.6 456.0 L175.6 459.0 L175.1 462.0 L175.1 465.0 L175.6 468.0 L176.6 471.0 L178.1 474.0 L180.1 477.0 L182.4 480.0 L185.0 483.0 L187.8 486.0 L190.8 489.0 L193.8 492.0 L196.7 495.0 L199.5 498.0 L202.1 501.0 L204.3 504.0 L206.2 507.0 L207.6 510.0 L208.5 513.0 L209.0 516.0 L208.9 519.0 L208.2 522.0 L207.1 525.0 L205.5 528.0 L203.5 531.0 L201.1 534.0 L198.5 537.0 L195.6 540.0 L192.6 543.0" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round"/>
<circle cx="192" cy="330.0" r="5" fill="currentColor"/>
<circle cx="192" cy="356.7" r="5" fill="currentColor"/>
<circle cx="192" cy="383.4" r="5" fill="currentColor"/>
<circle cx="192" cy="410.1" r="5" fill="currentColor"/>
<circle cx="192" cy="436.8" r="5" fill="currentColor"/>
<circle cx="192" cy="463.5" r="5" fill="currentColor"/>
<circle cx="192" cy="490.2" r="5" fill="currentColor"/>
<g transform="translate(192 170) rotate(0)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="6" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<g transform="translate(192 555) rotate(180)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="6" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<path d="M192 560 L165 590 L192 600 L219 590Z" fill="none" stroke="currentColor" stroke-width="6" stroke-linejoin="round"/>
      </symbol>
    </svg>

    <div class="bg" aria-hidden="true">
      <div class="lattice"></div>
      <svg class="bg-cross"><use href="#hk-cross" /></svg>
    </div>

    <div class="help-container">
      <!-- ============ EN-TÊTE ============ -->
      <header class="page-heading">
        <div class="heading-copy">
          <span class="kicker">
            <svg class="kicker-cross" aria-hidden="true"><use href="#hk-cross-sm" /></svg>
            HayMiutyun · Entraide
          </span>
          <h1>Demander de <em>l'aide</em></h1>
          <p>
            Chaque situation compte. Explique ton besoin pour permettre
            à la communauté de t'accompagner.
          </p>
        </div>

        <div class="heading-mark" aria-hidden="true">
          <svg class="mark-cross"><use href="#hk-cross-sm" /></svg>
        </div>
      </header>

      <div class="help-layout">
        <!-- ============ FORMULAIRE ============ -->
        <section class="form-card">
          <div class="card-heading">
            <div class="step-mark">01</div>
            <div>
              <h2>Ta demande</h2>
              <p>Présente ta situation et explique ton besoin.</p>
            </div>
          </div>

          <form @submit.prevent="submitRequest">
            <div class="form-grid">
              <div class="field field-full">
                <label for="request-title">Titre de la demande <span>*</span></label>
                <input
                  id="request-title"
                  v-model="form.name"
                  placeholder="Ex. Recherche d'un logement étudiant"
                  required
                />
              </div>

              <div class="field">
                <label for="request-email">Adresse e-mail <span>*</span></label>
                <input
                  id="request-email"
                  v-model="form.email"
                  type="email"
                  placeholder="exemple@email.com"
                  autocomplete="email"
                  required
                />
              </div>

              <div class="field">
                <label for="request-phone">
                  Téléphone <span class="optional">(optionnel)</span>
                </label>
                <input
                  id="request-phone"
                  v-model="form.phone"
                  type="tel"
                  placeholder="06 12 34 56 78"
                  autocomplete="tel"
                />
              </div>
            </div>

            <div class="form-divider"></div>

            <!-- Localisation -->
            <section class="form-section">
              <div class="section-heading">
                <div class="section-icon">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s-7-6-7-11a7 7 0 0 1 14 0c0 5-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>
                </div>
                <div>
                  <h3>Localisation</h3>
                  <p>Pour faciliter la mise en relation près de chez toi.</p>
                </div>
                <span class="optional-tag">Optionnel</span>
              </div>

              <div class="location-input">
                <span class="location-symbol" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-6-7-11a7 7 0 0 1 14 0c0 5-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>
                </span>
                <input
                  id="request-location"
                  v-model="form.location"
                  type="text"
                  placeholder="Ville, quartier ou adresse..."
                  autocomplete="off"
                  aria-label="Localisation"
                  @input="searchAddress"
                  @keydown.esc="addressSuggestions = []"
                />

                <button
                  v-if="form.location"
                  class="clear-location"
                  type="button"
                  aria-label="Effacer la localisation"
                  @click="form.location = ''; addressSuggestions = []"
                >
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>
                </button>

                <div
                  v-if="addressSuggestions.length"
                  class="address-suggestions"
                >
                  <button
                    v-for="address in addressSuggestions"
                    :key="address.properties?.id || address.properties?.label || address.label"
                    type="button"
                    class="address-suggestion"
                    @click="selectAddress(address)"
                  >
                    <span class="suggestion-pin" aria-hidden="true">
                      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-6-7-11a7 7 0 0 1 14 0c0 5-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>
                    </span>
                    <span>{{ address.properties?.label || address.label }}</span>
                  </button>
                </div>
              </div>

              <p class="field-hint">
                Tu peux indiquer une ville, un quartier ou une adresse précise.
              </p>
            </section>

            <div class="form-divider"></div>

            <!-- Urgence -->
            <section class="form-section">
              <div class="section-heading">
                <div class="section-icon">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3 2.5 20h19L12 3z"/><path d="M12 10v4m0 3v.1"/></svg>
                </div>
                <div>
                  <h3>Niveau d'urgence</h3>
                  <p>Sélectionne le niveau correspondant à ta situation.</p>
                </div>
              </div>

              <div class="urgency-options" role="group" aria-label="Niveau d'urgence">
                <button
                  v-for="level in urgencyLevels"
                  :key="level.value"
                  type="button"
                  class="urgency-card"
                  :class="[level.cls, { selected: form.urgency === level.value }]"
                  :aria-pressed="form.urgency === level.value"
                  @click="form.urgency = level.value"
                >
                  <span class="urgency-indicator"></span>
                  <span class="urgency-content">
                    <strong>{{ level.value }}</strong>
                    <span>{{ level.text }}</span>
                  </span>
                  <span class="selection-mark">
                    <svg v-if="form.urgency === level.value" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>
                  </span>
                </button>
              </div>

              <div v-if="!form.urgency" class="error">
                Merci de sélectionner un niveau d'urgence.
              </div>

              <div class="warning-box">
                <span class="warning-symbol" aria-hidden="true">!</span>
                <div>
                  <strong>Choisis le niveau avec attention</strong>
                  <p>
                    Merci de sélectionner un niveau correspondant réellement
                    à ta situation. Une demande dont le niveau est manifestement
                    inadapté pourra ne pas être prise en compte.
                  </p>
                </div>
              </div>
            </section>

            <div class="form-divider"></div>

            <!-- Description -->
            <section class="form-section">
              <div class="section-heading">
                <div class="section-icon">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20h4L19 9a2.8 2.8 0 0 0-4-4L4 16v4z"/><path d="m13.5 6.5 4 4"/></svg>
                </div>
                <div>
                  <h3>Décris ton besoin</h3>
                  <p>Plus tu donnes de détails, mieux la communauté pourra t'aider.</p>
                </div>
              </div>

              <div class="field">
                <label for="request-message">Description <span>*</span></label>
                <textarea
                  id="request-message"
                  v-model="form.message"
                  placeholder="Explique ta situation, ce dont tu as besoin et comment la communauté peut t'aider..."
                  required
                  rows="6"
                ></textarea>
              </div>
            </section>

            <div class="form-divider"></div>

            <!-- Photo -->
            <section class="form-section">
              <div class="section-heading">
                <div class="section-icon">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="3"/><circle cx="9" cy="10" r="1.8"/><path d="m21 16-5-5-8 9"/></svg>
                </div>
                <div>
                  <h3>Ajouter une photo</h3>
                  <p>Une image peut aider à mieux comprendre la situation.</p>
                </div>
                <span class="optional-tag">Optionnel</span>
              </div>

              <label class="upload-zone">
                <input
                  type="file"
                  accept="image/*"
                  @change="handleFile"
                />
                <span class="upload-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4m-5 5 5-5 5 5"/><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></svg>
                </span>
                <span class="upload-copy">
                  <strong>Choisir une image</strong>
                  <span>Sélectionne un fichier sur ton appareil</span>
                </span>
                <span class="upload-action">Parcourir</span>
              </label>

              <div v-if="preview" class="preview">
                <img :src="preview" alt="Aperçu de la photo sélectionnée" />
                <div class="preview-info">
                  <strong>Photo sélectionnée</strong>
                  <span>{{ file?.name }}</span>
                </div>
                <button
                  type="button"
                  class="remove-photo"
                  aria-label="Supprimer la photo"
                  @click="removeFile"
                >
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>
                </button>
              </div>
            </section>

            <div class="form-divider"></div>

            <!-- Consentement -->
            <section class="form-section">
              <div class="section-heading">
                <div class="section-icon">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3 4.5 6v5.5c0 4.6 3.1 8.2 7.5 9.5 4.4-1.3 7.5-4.9 7.5-9.5V6L12 3z"/><path d="m9 12 2.2 2.2L15.5 10"/></svg>
                </div>
                <div>
                  <h3>Publication et consentement</h3>
                  <p>Tu gardes le contrôle sur les informations partagées.</p>
                </div>
              </div>

              <div class="consent-list">
                <label class="checkbox-card">
                  <input
                    v-model="form.showPhone"
                    type="checkbox"
                  />
                  <span class="custom-checkbox"></span>
                  <span class="checkbox-copy">
                    <strong>Afficher mon numéro de téléphone</strong>
                    <span>
                      J'autorise HayMiutyun à afficher le numéro indiqué
                      afin que les personnes puissent me contacter directement.
                    </span>
                  </span>
                </label>

                <label class="checkbox-card">
                  <input
                    v-model="form.acceptTerms"
                    type="checkbox"
                    required
                  />
                  <span class="custom-checkbox"></span>
                  <span class="checkbox-copy">
                    <strong>J'accepte le traitement de ma demande <span>*</span></strong>
                    <span>
                      J'accepte que mes informations soient utilisées pour traiter
                      ma demande d'aide et que celle-ci soit publiée de manière
                      anonymisée afin que la communauté puisse proposer son aide.
                    </span>
                  </span>
                </label>
              </div>

              <p v-if="!form.acceptTerms" class="consent-hint">
                Le consentement est nécessaire pour envoyer la demande.
              </p>
            </section>

            <div class="submit-area">
              <button
                type="submit"
                class="submit-btn"
                :disabled="isSubmitting"
                :class="{ loading: isSubmitting }"
              >
                <span v-if="isSubmitting" class="spinner"></span>
                <span>
                  {{ isSubmitting ? 'Envoi en cours...' : 'Envoyer ma demande' }}
                </span>
                <svg v-if="!isSubmitting" class="submit-arrow" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6"/></svg>
              </button>

              <p class="privacy-note">
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>
                Tes informations sont utilisées dans le cadre de ta demande.
              </p>
            </div>
          </form>
        </section>

        <!-- ============ ASIDE ============ -->
        <aside class="help-aside">
          <svg class="aside-cross" aria-hidden="true"><use href="#hk-cross" /></svg>

          <span class="aside-kicker">L'esprit HayMiutyun</span>

          <h2>Personne ne devrait avoir à <em>tout affronter seul.</em></h2>

          <p class="aside-description">
            Ta demande peut être le début d'une belle rencontre et d'une
            solution concrète.
          </p>

          <div class="aside-rule"></div>

          <div class="aside-point">
            <span class="point-number">01</span>
            <div>
              <strong>Explique ta situation</strong>
              <p>Partage les informations utiles à ta demande.</p>
            </div>
          </div>

          <div class="aside-point">
            <span class="point-number">02</span>
            <div>
              <strong>La communauté se mobilise</strong>
              <p>Des personnes peuvent te proposer leur aide.</p>
            </div>
          </div>

          <div class="aside-point">
            <span class="point-number">03</span>
            <div>
              <strong>Avançons ensemble</strong>
              <p>Chaque contribution peut faire la différence.</p>
            </div>
          </div>

          <div class="aside-bottom">
            <span class="aside-line"></span>
            <span>Միասին ավելի ուժեղ — Plus forts ensemble</span>
          </div>
        </aside>
      </div>
    </div>
  </main>
</template>

<script setup>
import { reactive, ref, onBeforeUnmount } from 'vue'
import API_URL from '@/config/api'

const isSubmitting = ref(false)
const addressSuggestions = ref([])
const file = ref(null)
const preview = ref(null)

const urgencyLevels = [
  { value: 'Normal', cls: 'normal', text: 'La demande peut attendre un peu.' },
  { value: 'Important', cls: 'important', text: 'Une aide est nécessaire rapidement.' },
  { value: 'Urgent', cls: 'urgent', text: 'La situation nécessite une intervention immédiate.' }
]

const user = (() => {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null')
  } catch {
    return null
  }
})()

let searchTimeout = null
let searchController = null
let previewUrl = null

const form = reactive({
  name: '',
  email: '',
  phone: '',
  location: '',
  message: '',
  showPhone: false,
  acceptTerms: false,
  urgency: 'Normal',
  publish: false
})

const removeFile = () => {
  if (previewUrl) {
    URL.revokeObjectURL(previewUrl)
    previewUrl = null
  }

  file.value = null
  preview.value = null
}

const handleFile = (e) => {
  const selected = e.target.files?.[0]

  if (!selected) {
    removeFile()
    return
  }

  if (!selected.type.startsWith('image/')) {
    alert('Merci de sélectionner un fichier image.')
    e.target.value = ''
    removeFile()
    return
  }

  removeFile()
  file.value = selected
  previewUrl = URL.createObjectURL(selected)
  preview.value = previewUrl
}

const searchAddress = () => {
  clearTimeout(searchTimeout)

  if (searchController) {
    searchController.abort()
    searchController = null
  }

  const text = form.location.trim()

  if (text.length < 3) {
    addressSuggestions.value = []
    return
  }

  searchTimeout = setTimeout(async () => {
    const controller = new AbortController()
    searchController = controller

    try {
      const response = await fetch(
        `https://data.geopf.fr/geocodage/search?q=${encodeURIComponent(text)}&limit=5`,
        { signal: controller.signal }
      )

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`)
      }

      const data = await response.json()

      if (form.location.trim() === text) {
        addressSuggestions.value = data.features || []
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Erreur recherche adresse :', error)
        addressSuggestions.value = []
      }
    } finally {
      if (searchController === controller) {
        searchController = null
      }
    }
  }, 300)
}

const selectAddress = (address) => {
  form.location = address.properties?.label || address.label || ''
  addressSuggestions.value = []

  if (searchController) {
    searchController.abort()
    searchController = null
  }

  clearTimeout(searchTimeout)
}

const submitRequest = async () => {
  if (isSubmitting.value) return

  if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
    alert('Merci de remplir tous les champs obligatoires.')
    return
  }

  if (!form.urgency) {
    alert('Merci de sélectionner un niveau d’urgence.')
    return
  }

  if (!form.acceptTerms) {
    alert("Vous devez accepter les conditions avant l'envoi.")
    return
  }

  if (!user || !user.id) {
    alert('Vous devez être connecté pour envoyer une demande.')
    return
  }

  isSubmitting.value = true

  try {
    const formData = new FormData()

    formData.append('userId', user.id)
    formData.append('name', form.name.trim())
    formData.append('email', form.email.trim())
    formData.append('phone', form.phone.trim())
    formData.append('message', form.message.trim())
    formData.append('location', form.location.trim())
    formData.append('showPhone', form.showPhone ? 'true' : 'false')
    formData.append('urgency', form.urgency)
    formData.append('publish', form.publish ? 'true' : 'false')

    if (file.value) {
      formData.append('image', file.value)
    }

    const response = await fetch(`${API_URL}/api/HelpRequests`, {
      method: 'POST',
      body: formData
    })

    if (!response.ok) {
      let errorMessage = `Erreur lors de l'envoi (${response.status})`

      try {
        const errorData = await response.json()
        console.error('Erreur API :', errorData)

        if (errorData.message) {
          errorMessage = errorData.message
        }

        if (errorData.detail) {
          errorMessage += `\n${errorData.detail}`
        }
      } catch {
        const errorText = await response.text().catch(() => '')
        console.error('Erreur API texte :', errorText)

        if (errorText) {
          errorMessage = errorText
        }
      }

      throw new Error(errorMessage)
    }

    alert('Demande envoyée avec succès.')

    form.name = ''
    form.email = ''
    form.phone = ''
    form.message = ''
    form.location = ''
    form.showPhone = false
    form.acceptTerms = false
    form.urgency = 'Normal'
    form.publish = false
    addressSuggestions.value = []

    removeFile()

    const fileInput = document.querySelector('.upload-zone input[type="file"]')
    if (fileInput) fileInput.value = ''
  } catch (error) {
    console.error("Erreur d'envoi de la demande :", error)
    alert(`Impossible d'envoyer la demande.\n\n${error.message}`)
  } finally {
    isSubmitting.value = false
  }
}

onBeforeUnmount(() => {
  clearTimeout(searchTimeout)

  if (searchController) {
    searchController.abort()
  }

  if (previewUrl) {
    URL.revokeObjectURL(previewUrl)
  }
})
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,600;9..144,700&family=Instrument+Sans:wght@400;500;600;700&family=Noto+Serif+Armenian:wght@400;700&display=swap");
</style>

<style scoped>
.help-page {
  --red: #d90012;
  --red-deep: #8f0010;
  --blue: #0033a0;
  --orange: #f2a800;
  --green: #16a34a;
  --ink: #1c1511;
  --ink-soft: #3a2f28;
  --muted: #6e6259;
  --paper: #faf6ef;
  --paper-2: #f3ecdf;
  --line: rgba(28, 21, 17, 0.12);
  --serif: "Fraunces", "Noto Serif Armenian", Georgia, serif;
  --sans: "Instrument Sans", "Inter", system-ui, sans-serif;
  --arm: "Noto Serif Armenian", "Fraunces", serif;

  position: relative;
  min-height: 100vh;
  padding: 130px clamp(16px, 5vw, 72px) 100px;
  overflow: hidden;
  background: var(--paper);
  color: var(--ink);
  font-family: var(--sans);
  -webkit-font-smoothing: antialiased;
}
.help-page *,
.help-page *::before,
.help-page *::after {
  box-sizing: border-box;
}

/* ---------- fond ---------- */
.bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.lattice {
  position: absolute;
  inset: 0 0 auto 0;
  height: 620px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='104' height='163' viewBox='-60 -50 505 792' fill='none' opacity='.24'%3E%3Cmask id='m' maskUnits='userSpaceOnUse' x='-20' y='-20' width='425' height='710'%3E%3Crect x='-20' y='-20' width='425' height='710' fill='%23fff'/%3E%3Cpath d='M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z' fill='none' stroke='%23000' stroke-width='6' stroke-linejoin='round'/%3E%3C/mask%3E%3Cpath d='M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z' fill='none' stroke='%23d90012' stroke-width='19' stroke-linejoin='round' mask='url(%23m)'/%3E%3Cg transform='translate(98 40) rotate(-45)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(287 40) rotate(45)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(356 166) rotate(70)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(356 344) rotate(110)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(291 645) rotate(135)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(97 645) rotate(-135)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(29 344) rotate(-110)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(29 166) rotate(-70)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Ccircle cx='140' cy='44' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='140' cy='44' r='7' fill='%23d90012'/%3E%3Ccircle cx='245' cy='44' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='245' cy='44' r='7' fill='%23d90012'/%3E%3Ccircle cx='112' cy='88' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='112' cy='88' r='7' fill='%23d90012'/%3E%3Ccircle cx='272' cy='88' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='272' cy='88' r='7' fill='%23d90012'/%3E%3Ccircle cx='48' cy='208' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='48' cy='208' r='7' fill='%23d90012'/%3E%3Ccircle cx='48' cy='302' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='48' cy='302' r='7' fill='%23d90012'/%3E%3Ccircle cx='338' cy='208' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='338' cy='208' r='7' fill='%23d90012'/%3E%3Ccircle cx='338' cy='302' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='338' cy='302' r='7' fill='%23d90012'/%3E%3Ccircle cx='140' cy='602' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='140' cy='602' r='7' fill='%23d90012'/%3E%3Ccircle cx='245' cy='602' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='245' cy='602' r='7' fill='%23d90012'/%3E%3Ccircle cx='110' cy='592' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='110' cy='592' r='7' fill='%23d90012'/%3E%3Ccircle cx='275' cy='592' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='275' cy='592' r='7' fill='%23d90012'/%3E%3Ccircle cx='192' cy='245' r='76' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Cline x1='254.0' y1='245.0' x2='266.0' y2='245.0' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='250.3' y1='266.2' x2='261.5' y2='270.3' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='239.5' y1='284.9' x2='248.7' y2='292.6' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='223.0' y1='298.7' x2='229.0' y2='309.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='202.8' y1='306.1' x2='204.8' y2='317.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='181.2' y1='306.1' x2='179.2' y2='317.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='161.0' y1='298.7' x2='155.0' y2='309.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='144.5' y1='284.9' x2='135.3' y2='292.6' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='133.7' y1='266.2' x2='122.5' y2='270.3' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='130.0' y1='245.0' x2='118.0' y2='245.0' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='133.7' y1='223.8' x2='122.5' y2='219.7' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='144.5' y1='205.1' x2='135.3' y2='197.4' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='161.0' y1='191.3' x2='155.0' y2='180.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='181.2' y1='183.9' x2='179.2' y2='172.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='202.8' y1='183.9' x2='204.8' y2='172.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='223.0' y1='191.3' x2='229.0' y2='180.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='239.5' y1='205.1' x2='248.7' y2='197.4' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='250.3' y1='223.8' x2='261.5' y2='219.7' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Ccircle cx='192' cy='245' r='54' fill='none' stroke='%23d90012' stroke-width='9'/%3E%3Cpath d='M207.0 245.0 L209.9 247.4 L212.4 250.7 L214.3 254.6 L215.5 259.1 L215.8 264.1 L215.2 269.3 L213.5 274.7 L210.8 280.1 L206.9 285.2 L202.1 289.9' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M201.4 256.7 L201.3 260.5 L200.3 264.5 L198.4 268.4 L195.6 272.2 L191.9 275.5 L187.4 278.3 L182.1 280.4 L176.3 281.6 L169.9 281.8 L163.2 280.9' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M188.7 259.6 L185.6 261.9 L181.9 263.7 L177.7 264.6 L173.0 264.8 L168.1 264.0 L163.1 262.2 L158.2 259.3 L153.6 255.5 L149.5 250.6 L146.0 244.8' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M178.5 251.5 L174.8 250.6 L171.1 248.8 L167.7 246.1 L164.7 242.5 L162.3 238.2 L160.6 233.1 L159.7 227.5 L159.9 221.5 L161.1 215.3 L163.4 208.9' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M178.5 238.5 L176.9 235.0 L176.0 231.0 L176.0 226.7 L176.9 222.1 L178.8 217.5 L181.7 213.0 L185.5 208.9 L190.3 205.2 L196.0 202.3 L202.4 200.2' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M188.7 230.4 L190.4 227.0 L193.0 223.8 L196.4 221.1 L200.5 219.0 L205.3 217.5 L210.6 217.0 L216.2 217.4 L222.0 218.9 L227.9 221.5 L233.5 225.2' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M201.4 233.3 L205.1 232.5 L209.2 232.6 L213.4 233.5 L217.7 235.4 L221.7 238.3 L225.5 242.1 L228.7 246.7 L231.1 252.2 L232.8 258.4 L233.4 265.1' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Ccircle cx='192' cy='245' r='9' fill='%23d90012'/%3E%3Cpath d='M192.0 330.0 L195.0 333.0 L197.9 336.0 L200.6 339.0 L203.0 342.0 L205.1 345.0 L206.8 348.0 L208.1 351.0 L208.8 354.0 L209.0 357.0 L208.7 360.0 L207.8 363.0 L206.5 366.0 L204.7 369.0 L202.6 372.0 L200.1 375.0 L197.3 378.0 L194.4 381.0 L191.4 384.0 L188.4 387.0 L185.6 390.0 L182.9 393.0 L180.5 396.0 L178.5 399.0 L176.9 402.0 L175.8 405.0 L175.1 408.0 L175.0 411.0 L175.4 414.0 L176.4 417.0 L177.8 420.0 L179.7 423.0 L181.9 426.0 L184.5 429.0 L187.2 432.0 L190.2 435.0 L193.2 438.0 L196.1 441.0 L199.0 444.0 L201.6 447.0 L203.9 450.0 L205.8 453.0 L207.4 456.0 L208.4 459.0 L208.9 462.0 L208.9 465.0 L208.4 468.0 L207.4 471.0 L205.9 474.0 L203.9 477.0 L201.6 480.0 L199.0 483.0 L196.2 486.0 L193.2 489.0 L190.2 492.0 L187.3 495.0 L184.5 498.0 L181.9 501.0 L179.7 504.0 L177.8 507.0 L176.4 510.0 L175.5 513.0 L175.0 516.0 L175.1 519.0 L175.8 522.0 L176.9 525.0 L178.5 528.0 L180.5 531.0 L182.9 534.0 L185.5 537.0 L188.4 540.0 L191.4 543.0' fill='none' stroke='%23d90012' stroke-width='10' stroke-linecap='round'/%3E%3Cpath d='M192.0 330.0 L189.0 333.0 L186.1 336.0 L183.4 339.0 L181.0 342.0 L178.9 345.0 L177.2 348.0 L175.9 351.0 L175.2 354.0 L175.0 357.0 L175.3 360.0 L176.2 363.0 L177.5 366.0 L179.3 369.0 L181.4 372.0 L183.9 375.0 L186.7 378.0 L189.6 381.0 L192.6 384.0 L195.6 387.0 L198.4 390.0 L201.1 393.0 L203.5 396.0 L205.5 399.0 L207.1 402.0 L208.2 405.0 L208.9 408.0 L209.0 411.0 L208.6 414.0 L207.6 417.0 L206.2 420.0 L204.3 423.0 L202.1 426.0 L199.5 429.0 L196.8 432.0 L193.8 435.0 L190.8 438.0 L187.9 441.0 L185.0 444.0 L182.4 447.0 L180.1 450.0 L178.2 453.0 L176.6 456.0 L175.6 459.0 L175.1 462.0 L175.1 465.0 L175.6 468.0 L176.6 471.0 L178.1 474.0 L180.1 477.0 L182.4 480.0 L185.0 483.0 L187.8 486.0 L190.8 489.0 L193.8 492.0 L196.7 495.0 L199.5 498.0 L202.1 501.0 L204.3 504.0 L206.2 507.0 L207.6 510.0 L208.5 513.0 L209.0 516.0 L208.9 519.0 L208.2 522.0 L207.1 525.0 L205.5 528.0 L203.5 531.0 L201.1 534.0 L198.5 537.0 L195.6 540.0 L192.6 543.0' fill='none' stroke='%23d90012' stroke-width='10' stroke-linecap='round'/%3E%3Ccircle cx='192' cy='330.0' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='356.7' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='383.4' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='410.1' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='436.8' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='463.5' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='490.2' r='5' fill='%23d90012'/%3E%3Cg transform='translate(192 170) rotate(0)'%3E%3Cpath d='M0 18 L0 -6' stroke='%23d90012' stroke-width='6' stroke-linecap='round'/%3E%3Cpath d='M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(192 555) rotate(180)'%3E%3Cpath d='M0 18 L0 -6' stroke='%23d90012' stroke-width='6' stroke-linecap='round'/%3E%3Cpath d='M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z' fill='%23d90012'/%3E%3C/g%3E%3Cpath d='M192 560 L165 590 L192 600 L219 590Z' fill='none' stroke='%23d90012' stroke-width='6' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-size: 104px 163px;
  -webkit-mask-image: radial-gradient(ellipse 70% 80% at 50% 0%, #000 0%, transparent 75%);
  mask-image: radial-gradient(ellipse 70% 80% at 50% 0%, #000 0%, transparent 75%);
}
.bg-cross {
  position: absolute;
  top: 56px;
  right: clamp(150px, 17vw, 300px);
  width: clamp(120px, 14vw, 220px);
  aspect-ratio: 453 / 752;
  height: auto;
  color: rgba(217, 0, 18, 0.1);
  user-select: none;
}

.help-container {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

/* ---------- en-tête ---------- */
.page-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  margin-bottom: 44px;
  animation: rise 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
.kicker,
.aside-kicker {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--red);
  font: 700 13px/1 var(--sans);
  letter-spacing: 0.16em;
  text-transform: uppercase;
}
.kicker-cross {
  width: 19px;
  height: 32px;
  flex-shrink: 0;
}
.kicker::before {
  width: 28px;
  height: 2px;
  background: var(--red);
  content: "";
}
.heading-copy h1 {
  margin: 16px 0 0;
  font: 600 clamp(38px, 5.4vw, 66px) / 1.06 var(--serif);
  letter-spacing: -0.03em;
}
.heading-copy h1 em {
  color: var(--red);
  font-weight: 500;
}
.heading-copy p {
  max-width: 560px;
  margin: 20px 0 0;
  color: var(--ink-soft);
  font-size: clamp(16px, 1.5vw, 18px);
  line-height: 1.7;
}
.heading-mark {
  position: relative;
  display: grid;
  flex-shrink: 0;
  width: 112px;
  height: 112px;
  place-items: center;
  border-radius: 50%;
  background: var(--ink);
  box-shadow: 0 24px 48px rgba(28, 21, 17, 0.25);
}
.heading-mark::after {
  position: absolute;
  inset: -9px;
  border: 1.5px dashed rgba(242, 168, 0, 0.75);
  border-radius: 50%;
  content: "";
  animation: spin 24s linear infinite;
}
.mark-cross {
  width: 40px;
  aspect-ratio: 473 / 752;
  height: auto;
  color: var(--orange);
}

/* ---------- mise en page ---------- */
.help-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  align-items: start;
  gap: 28px;
}

/* ---------- carte formulaire ---------- */
.form-card {
  position: relative;
  min-width: 0;
  padding: clamp(24px, 4vw, 46px);
  border: 1px solid var(--line);
  border-radius: 32px;
  background: #fff;
  box-shadow: 0 24px 60px rgba(28, 21, 17, 0.08);
  animation: rise 0.8s 0.08s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
.form-card::before {
  position: absolute;
  inset: 0 32px auto;
  height: 4px;
  border-radius: 0 0 4px 4px;
  background: linear-gradient(90deg, var(--red) 0 42%, var(--blue) 42% 72%, var(--orange) 72%);
  content: "";
}
.card-heading {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 34px;
}
.step-mark {
  display: grid;
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  place-items: center;
  border-radius: 16px;
  background: var(--ink);
  color: var(--orange);
  font: 700 17px/1 var(--serif);
}
.card-heading h2 {
  margin: 0 0 4px;
  font: 600 30px/1.15 var(--serif);
  letter-spacing: -0.025em;
}
.card-heading p {
  margin: 0;
  color: var(--muted);
  font-size: 15px;
  line-height: 1.6;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 22px 18px;
}
.field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 9px;
}
.field-full {
  grid-column: 1 / -1;
}
.field label {
  color: var(--ink);
  font-size: 14px;
  font-weight: 700;
}
.field label > span:not(.optional) {
  color: var(--red);
}
.optional {
  color: var(--muted);
  font-size: 13px;
  font-weight: 500;
}

.field input,
.field textarea,
.location-input input {
  width: 100%;
  min-width: 0;
  border: 1.5px solid transparent;
  border-radius: 16px;
  outline: none;
  background: var(--paper);
  color: var(--ink);
  font: 500 16px var(--sans);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}
.field input {
  height: 56px;
  padding: 0 18px;
}
.field textarea {
  min-height: 170px;
  padding: 16px 18px;
  line-height: 1.7;
  resize: vertical;
}
.field input::placeholder,
.field textarea::placeholder,
.location-input input::placeholder {
  color: var(--muted);
  opacity: 0.75;
}
.field input:hover,
.field textarea:hover,
.location-input input:hover {
  border-color: var(--line);
}
.field input:focus,
.field textarea:focus,
.location-input input:focus {
  border-color: var(--red);
  background: #fff;
  box-shadow: 0 0 0 4px rgba(217, 0, 18, 0.08);
}

.form-divider {
  height: 1px;
  margin: 36px 0;
  background: var(--line);
}

/* ---------- sections ---------- */
.section-heading {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
}
.section-icon {
  display: grid;
  width: 46px;
  height: 46px;
  flex-shrink: 0;
  place-items: center;
  border-radius: 14px;
  background: var(--paper-2);
  color: var(--red);
}
.section-heading h3 {
  margin: 0 0 3px;
  font: 600 21px/1.2 var(--serif);
  letter-spacing: -0.02em;
}
.section-heading p {
  margin: 0;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.55;
}
.optional-tag {
  flex-shrink: 0;
  margin-left: auto;
  padding: 7px 12px;
  border: 1px solid var(--line);
  border-radius: 999px;
  color: var(--muted);
  font: 700 11px/1 var(--sans);
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

/* ---------- localisation ---------- */
.location-input {
  position: relative;
}
.location-input input {
  height: 56px;
  padding: 0 48px;
}
.location-symbol {
  position: absolute;
  top: 50%;
  left: 17px;
  z-index: 1;
  display: grid;
  transform: translateY(-50%);
  color: var(--red);
  pointer-events: none;
}
.clear-location {
  position: absolute;
  top: 50%;
  right: 10px;
  display: grid;
  width: 34px;
  height: 34px;
  transform: translateY(-50%);
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--muted);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}
.clear-location:hover {
  background: var(--paper-2);
  color: var(--ink);
}
.address-suggestions {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  left: 0;
  z-index: 20;
  overflow: hidden;
  border: 1px solid var(--line);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 24px 50px rgba(28, 21, 17, 0.16);
}
.address-suggestion {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border: 0;
  border-bottom: 1px solid var(--line);
  background: transparent;
  color: var(--ink);
  font: 500 15px/1.5 var(--sans);
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease;
}
.address-suggestion:last-child {
  border-bottom: 0;
}
.address-suggestion:hover {
  background: var(--paper);
}
.suggestion-pin {
  display: grid;
  flex-shrink: 0;
  color: var(--red);
}
.field-hint {
  margin: 10px 0 0;
  color: var(--muted);
  font-size: 13.5px;
  line-height: 1.6;
}

/* ---------- urgence ---------- */
.urgency-options {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}
.urgency-card {
  --tone: var(--green);
  --tone-bg: #effaf2;
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 132px;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 16px;
  border: 1.5px solid var(--line);
  border-radius: 20px;
  background: #fff;
  color: var(--ink);
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: transform 0.25s ease, border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
}
.urgency-card.important {
  --tone: var(--orange);
  --tone-bg: #fff7e4;
}
.urgency-card.urgent {
  --tone: var(--red);
  --tone-bg: #fff0ee;
}
.urgency-card:hover {
  transform: translateY(-3px);
  border-color: var(--tone);
  box-shadow: 0 14px 30px rgba(28, 21, 17, 0.08);
}
.urgency-card.selected {
  border-color: var(--tone);
  background: var(--tone-bg);
  box-shadow: 0 0 0 4px color-mix(in srgb, var(--tone) 16%, transparent);
}
.urgency-indicator {
  width: 11px;
  height: 11px;
  flex-shrink: 0;
  margin-top: 5px;
  border-radius: 50%;
  background: var(--tone);
}
.urgency-card.urgent.selected .urgency-indicator {
  animation: pulse 1.8s ease-out infinite;
}
.urgency-content {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 8px;
}
.urgency-content strong {
  font: 600 19px/1.1 var(--serif);
  letter-spacing: -0.015em;
}
.urgency-content > span {
  color: var(--muted);
  font-size: 13.5px;
  line-height: 1.55;
}
.selection-mark {
  display: grid;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  place-items: center;
  border: 1.5px solid var(--line);
  border-radius: 50%;
  color: #fff;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.urgency-card.selected .selection-mark {
  border-color: var(--tone);
  background: var(--tone);
}
.urgency-card:focus-visible,
.upload-zone:focus-within,
.submit-btn:focus-visible {
  outline: 3px solid var(--orange);
  outline-offset: 3px;
}
@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(217, 0, 18, 0.5); }
  70%, 100% { box-shadow: 0 0 0 9px rgba(217, 0, 18, 0); }
}

.warning-box {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-top: 18px;
  padding: 18px 20px;
  border: 1px solid rgba(242, 168, 0, 0.4);
  border-radius: 20px;
  background: #fff8e8;
}
.warning-symbol {
  display: grid;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  place-items: center;
  border-radius: 50%;
  background: var(--orange);
  color: var(--ink);
  font: 700 15px/1 var(--sans);
}
.warning-box strong {
  display: block;
  margin-bottom: 6px;
  color: #6b4a00;
  font-size: 15px;
}
.warning-box p {
  margin: 0;
  color: #7d6021;
  font-size: 14px;
  line-height: 1.7;
}
.error {
  margin-top: 12px;
  color: var(--red);
  font-size: 14px;
  font-weight: 600;
}

/* ---------- photo ---------- */
.upload-zone {
  position: relative;
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 16px;
  padding: 20px;
  border: 1.5px dashed rgba(28, 21, 17, 0.28);
  border-radius: 22px;
  background: var(--paper);
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease, transform 0.25s ease;
}
.upload-zone:hover {
  border-color: var(--red);
  background: #fff6f4;
  transform: translateY(-2px);
}
.upload-zone input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
  white-space: nowrap;
}
.upload-icon {
  display: grid;
  width: 52px;
  height: 52px;
  flex-shrink: 0;
  place-items: center;
  border-radius: 16px;
  background: var(--red);
  color: #fff;
  box-shadow: 0 10px 22px rgba(217, 0, 18, 0.28);
}
.upload-copy {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 4px;
}
.upload-copy strong {
  font-size: 16px;
}
.upload-copy > span {
  color: var(--muted);
  font-size: 14px;
  line-height: 1.5;
}
.upload-action {
  flex-shrink: 0;
  padding: 11px 18px;
  border: 1.5px solid var(--ink);
  border-radius: 999px;
  color: var(--ink);
  font-size: 14px;
  font-weight: 700;
  transition: background 0.2s ease, color 0.2s ease;
}
.upload-zone:hover .upload-action {
  background: var(--ink);
  color: #fff;
}

.preview {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 14px;
  padding: 12px;
  border: 1px solid var(--line);
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(28, 21, 17, 0.06);
}
.preview img {
  width: 76px;
  height: 76px;
  flex-shrink: 0;
  border-radius: 14px;
  object-fit: cover;
}
.preview-info {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 5px;
}
.preview-info strong {
  font-size: 15px;
}
.preview-info span {
  overflow: hidden;
  color: var(--muted);
  font-size: 13.5px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.remove-photo {
  display: grid;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  place-items: center;
  border: 0;
  border-radius: 50%;
  background: rgba(217, 0, 18, 0.08);
  color: var(--red);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}
.remove-photo:hover {
  background: var(--red);
  color: #fff;
}

/* ---------- consentement ---------- */
.consent-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.checkbox-card {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px 20px;
  border: 1.5px solid var(--line);
  border-radius: 20px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
}
.checkbox-card:hover {
  border-color: var(--ink);
  background: var(--paper);
}
.checkbox-card input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}
.custom-checkbox {
  display: grid;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  place-items: center;
  margin-top: 1px;
  border: 1.5px solid rgba(28, 21, 17, 0.35);
  border-radius: 8px;
  background: #fff;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.checkbox-card input:checked + .custom-checkbox {
  border-color: var(--red);
  background: var(--red);
}
.checkbox-card input:checked + .custom-checkbox::after {
  content: "✓";
}
.checkbox-card input:focus-visible + .custom-checkbox {
  outline: 3px solid var(--orange);
  outline-offset: 2px;
}
.checkbox-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 6px;
}
.checkbox-copy strong {
  font-size: 15.5px;
  line-height: 1.5;
}
.checkbox-copy strong span {
  color: var(--red);
}
.checkbox-copy > span {
  color: var(--muted);
  font-size: 14px;
  line-height: 1.7;
}
.consent-hint {
  margin: 12px 0 0;
  color: var(--red-deep);
  font-size: 13.5px;
  font-weight: 600;
}

/* ---------- envoi ---------- */
.submit-area {
  margin-top: 38px;
}
.submit-btn {
  display: flex;
  width: 100%;
  min-height: 60px;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 0 28px;
  border: 0;
  border-radius: 999px;
  background: var(--red);
  color: #fff;
  font: 700 17px/1 var(--sans);
  cursor: pointer;
  box-shadow: 0 14px 30px rgba(217, 0, 18, 0.32);
  transition: transform 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
}
.submit-btn:hover:not(:disabled) {
  transform: translateY(-3px);
  background: var(--red-deep);
  box-shadow: 0 20px 38px rgba(217, 0, 18, 0.38);
}
.submit-btn:hover:not(:disabled) .submit-arrow {
  transform: translateX(5px);
}
.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.submit-arrow {
  transition: transform 0.25s ease;
}
.privacy-note {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 16px 0 0;
  color: var(--muted);
  font-size: 13.5px;
  line-height: 1.6;
  text-align: center;
}
.privacy-note svg {
  flex-shrink: 0;
  color: var(--green);
}
.spinner {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  border: 2.5px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

/* ---------- aside ---------- */
.help-aside {
  position: sticky;
  top: 100px;
  isolation: isolate;
  padding: clamp(26px, 3vw, 36px);
  overflow: hidden;
  border-radius: 32px;
  background: var(--ink);
  color: var(--paper);
  box-shadow: 0 30px 70px rgba(28, 21, 17, 0.28);
  animation: rise 0.8s 0.2s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
.help-aside::before {
  position: absolute;
  z-index: -1;
  inset: 0 0 auto;
  height: 5px;
  background: linear-gradient(90deg, var(--red) 0 42%, var(--blue) 42% 72%, var(--orange) 72%);
  content: "";
}
.aside-cross {
  position: absolute;
  z-index: -1;
  right: -18px;
  bottom: -30px;
  width: 170px;
  aspect-ratio: 453 / 752;
  height: auto;
  color: rgba(242, 168, 0, 0.16);
  user-select: none;
}
.aside-kicker {
  color: var(--orange);
  font-size: 12px;
}
.aside-kicker::before {
  width: 22px;
  height: 2px;
  background: var(--orange);
  content: "";
}
.help-aside h2 {
  margin: 20px 0 0;
  font: 600 clamp(28px, 2.6vw, 34px) / 1.15 var(--serif);
  letter-spacing: -0.025em;
}
.help-aside h2 em {
  color: var(--orange);
  font-weight: 500;
}
.aside-description {
  margin: 16px 0 0;
  color: rgba(250, 246, 239, 0.7);
  font-size: 15.5px;
  line-height: 1.75;
}
.aside-rule {
  height: 1px;
  margin: 28px 0;
  background: rgba(250, 246, 239, 0.16);
}
.aside-point {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 24px;
}
.point-number {
  display: grid;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  place-items: center;
  border-radius: 13px;
  background: rgba(250, 246, 239, 0.08);
  color: var(--orange);
  font: 700 14px/1 var(--serif);
}
.aside-point strong {
  display: block;
  margin: 2px 0 5px;
  font-size: 16px;
}
.aside-point p {
  margin: 0;
  color: rgba(250, 246, 239, 0.62);
  font-size: 14px;
  line-height: 1.65;
}
.aside-bottom {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
  padding-top: 22px;
  border-top: 1px solid rgba(250, 246, 239, 0.16);
  color: rgba(250, 246, 239, 0.62);
  font-size: 13px;
  line-height: 1.6;
}
.aside-line {
  width: 24px;
  height: 2px;
  flex-shrink: 0;
  background: var(--orange);
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
@keyframes rise {
  from { opacity: 0; transform: translateY(26px); }
}

/* ---------- responsive ---------- */
@media (max-width: 1000px) {
  .help-layout {
    grid-template-columns: 1fr;
  }
  .help-aside {
    position: relative;
    top: auto;
  }
}

@media (max-width: 720px) {
  .help-page {
    padding-top: 108px;
    padding-bottom: 70px;
  }
  .page-heading {
    margin-bottom: 30px;
  }
  .heading-mark {
    width: 72px;
    height: 72px;
  }
  .mark-cross {
    width: 26px;
  }
  .bg-cross {
    top: 76px;
    right: -34px;
    width: 150px;
    opacity: 0.7;
  }
  .lattice {
    height: 480px;
    background-size: 80px 125px;
  }
  .form-card,
  .help-aside {
    border-radius: 24px;
  }
  .form-grid {
    grid-template-columns: 1fr;
    gap: 18px;
  }
  .field-full {
    grid-column: auto;
  }
  .urgency-options {
    grid-template-columns: 1fr;
  }
  .urgency-card {
    min-height: auto;
    align-items: center;
  }
  .section-heading {
    flex-wrap: wrap;
  }
  .optional-tag {
    margin-left: 60px;
  }
  .upload-zone {
    flex-wrap: wrap;
  }
  .upload-copy {
    flex-basis: calc(100% - 70px);
  }
  .upload-action {
    margin-left: 68px;
  }
}

@media (max-width: 480px) {
  .heading-mark {
    display: none;
  }
  .card-heading h2 {
    font-size: 26px;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    scroll-behavior: auto !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>